module.exports = __webpack_public_path__ + "static/media/threestepiconactive2.47828b63.png";